<template>
  <v-layout row class="ml-5" v-if="researchQuestionDisplay.showSection">
    <span class="question-text mr-2">{{ $t('ai.questionDisplayPrefix') }}</span>
    <span>{{ researchQuestion }}</span>
    <InlineActionBtn
      text="Edit"
      icon="edit"
      @onClickAction="handleEditClick"
    ></InlineActionBtn>
  </v-layout>
</template>

<script>
import { InlineActionBtn } from '../utils/buttons'
export default {
  name: 'ResearchQuestionDisplay',
  components: {InlineActionBtn},
  computed: {
    researchQuestion: {
      get () { return this.$store.getters.getResearchQuestion }
    },
    researchQuestionDisplay: {
      get () { return this.$store.getters.getResearchQuestionDisplayState }
    }
  },
  methods: {
    handleEditClick () {
      this.$store.dispatch('updateAiState', 0)
    }
  }
}
</script>

<style scoped>
.question-text {
  font-weight: bold;
  text-wrap: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/components/parts/searchAi/ResearchQuestionDisplay.vue